import { fg } from '@atlassian/jira-feature-gating';

const isJiraForgeCustomFieldsInIssueNavigatorEditEnabled = {
	get(): boolean {
		return fg('jira-forge-custom-fields-in-issue-navigator-edit');
	},
};

export default isJiraForgeCustomFieldsInIssueNavigatorEditEnabled;
